/**
 * Ochiq auksion lotlari (ijara-urmon.uz ko'rinishi) — avtorizatsiyasiz katalog.
 * Lot ro'yxati va lot kartasi `GET /lease/public/auctions/` orqali olinadi.
 */
import { api } from "@/shared/api/client";
import { qs } from "@/shared/api/endpoints";
import type { Query } from "@/shared/api/endpoints";

export type AuctionStatus = "active" | "completed" | "unsuccessful" | "contract";

export interface AuctionLotRow {
  id: string;
  lot_number: string;
  status: AuctionStatus;
  status_label: string;
  auction_type: string;
  region: number | null;
  region_name: string;
  forestry_code: string;
  farm_name: string;
  area_ha: string;
  purpose: string;
  starting_price: string;
  current_price: string;
  next_best_price: string;
  deposit_amount: string;
  start_at: string | null;
  end_at: string | null;
  participants_count: number;
  winner_name: string;
  winner_bid: string;
}

export interface AuctionLotDetail extends AuctionLotRow {
  district: number | null;
  forestry: number | null;
  division: string;
  contour: string;
  quarter: string;
  plot_label: string;
  cadastre_number: string;
  use_conditions: string;
  permitted_construction: string;
  restrictions: string;
  lease_term_years: number;
  bid_step: string;
  lease_right_amount: string;
  method: string;
  lessor_ownership: string;
  lessor_name: string;
  lessor_address: string;
  lessor_phone: string;
  lessor_email: string;
  winner_confirmed_at: string | null;
  documents: Array<{ name: string; url: string }>;
  is_sample: boolean;
  geojson: {
    features: Array<{
      id?: string | number;
      geometry: { type: string; coordinates: unknown } | null;
      properties: Record<string, unknown>;
    }>;
  };
  center: { lat: number; lon: number } | null;
}

export const auctionApi = {
  lots: (params: Query = {}) =>
    api.get<{ count: number; results: AuctionLotRow[] }>(`/lease/public/auctions/${qs(params)}`),
  lot: (lotNumber: string) =>
    api.get<AuctionLotDetail>(`/lease/public/auctions/${encodeURIComponent(lotNumber)}/`),
};

/** Lot holati yorlig'i: server matni o'rniga qisqa nomlar ko'rsatiladi. */
const STATUS_SHORT: Partial<Record<AuctionStatus, string>> = {
  completed: "Yakunlangan",
  contract: "Jarayonida",
};

export function lotStatusLabel(status: AuctionStatus, fallback: string): string {
  return STATUS_SHORT[status] ?? fallback;
}
